import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  connect() {
    this.element.addEventListener('linkCopied', this.resetButtonsState);
  }

  resetButtonsState = (event) => {
    this.element.querySelectorAll('button').forEach((element) => {
      element.dispatchEvent(
        new CustomEvent('resetButtonState', {
          detail: { url: event.detail.url },
          bubbles: true,
        }),
      );
    });
  };
}
